import { render } from "./ChartHorizontalBar.vue?vue&type=template&id=7fcbfbcc"
import script from "./ChartHorizontalBar.vue?vue&type=script&lang=js"
export * from "./ChartHorizontalBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/Advanced/ChartHorizontalBar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7fcbfbcc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7fcbfbcc', __exports__)) {
    api.reload('7fcbfbcc', __exports__)
  }
  
  module.hot.accept("./ChartHorizontalBar.vue?vue&type=template&id=7fcbfbcc", () => {
    api.rerender('7fcbfbcc', render)
  })

}


export default __exports__